import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Tabs } from 'antd'
import StatisticArapClientDetail from './StatisticArapClientDetail'
import StatisticArapClientTotal from './StatisticArapClientTotal'
import { UserOutlined, SkinOutlined } from '@ant-design/icons'
function StatisticArap(props) {
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_statistic_arap_active_key') || '0')
    return (
        <Main 
            selectedKeys='/StatisticArap' 
            qy_id={props.qy_id} 
            qy_name={props.qy_name} 
            yh_id={props.yh_id} 
            yh_name={props.yh_name} 
            yh_qx={props.yh_qx}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
        >
            <Tabs
                items={[
                    {
                        key: '0',
                        label: '客户明细',
                        children: <StatisticArapClientDetail  qy_id={props.qy_id} />,
                        icon: <UserOutlined />,
                    },
                    {
                        key: '1',
                        label: '客户余额汇总',
                        children: <StatisticArapClientTotal  qy_id={props.qy_id} />,
                        icon: <SkinOutlined />,
                    },
                ]}
                activeKey={activeKey}
                onChange={(key) => {
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_statistic_arap_active_key', key)
                }}
            />
        </Main>
    )
}

export default StatisticArap